import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from 'src/app/shared/constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SalesSourceService {

  constructor(public http:HttpClient) { }

  Baseurl(): string {
    return Constants.BASE_URL;
  }

  getSalesSource(locationId){
    return this.http.get<any>(this.Baseurl()+ 'Masters/GetSalesSource/'+locationId);
  }

  createSalesSource(sales): any {
    return this.http.post<any>(this.Baseurl() + 'Masters/PostSalesSourceMaster', sales, { observe: 'response' });
  }

  // GetPaymentAccounts
  getPaymentAccounts(locationId): any {
    return this.http.get<any>(this.Baseurl()+ 'AccountMaster/GetPaymentAccounts/'+locationId);
  }

  getPendingESaleInvoices(payload: any) {
    return this.http.post<any>(this.Baseurl() + 'SalesReport/GetPendingESaleInvoices', payload);
  }

  getPendingWayBills(payload: any) {
    return this.http.post<any>(this.Baseurl() + 'SalesReport/GetPendingWayBills', payload);
  }
  generateEInvoice(locationId: number, reTry: boolean, outwardNumber: string): Observable<any> {
    const endpoint = `${this.Baseurl()}GSTService/CreateEInvoice?locationId=${locationId}&reTry=${reTry}&outwardNumber=${outwardNumber}`;
    return this.http.post<any>(endpoint, {});
  }
  cancelEInvoice(locationId: number, outwardNumber: number, reason: string, remarks: string): Observable<any> {
    const endpoint = `${this.Baseurl()}GSTService/CancelEInvoice?locationId=${locationId}&outwardNumber=${outwardNumber}`;
    const payload = {
      Reason: reason,
      Remarks: remarks
    };
    return this.http.post<any>(endpoint, payload);
  }
  generateWayBill(locationId: number, outwardNumber: number, payload: any): Observable<any> {
    const endpoint = `${this.Baseurl()}GSTService/CreateEWaybill?locationId=${locationId}&outwardNumber=${outwardNumber}`;
    return this.http.post<any>(endpoint, payload, { observe: 'response' });
  }

  cancelWayBill(locationId: number, outwardNumber: number, reasonCode: number, remarks: string): Observable<any> {
    const endpoint = `${this.Baseurl()}GSTService/CancelEWaybill?locationId=${locationId}&outwardNumber=${outwardNumber}`;
    const payload = {
      ReasonCode: reasonCode,
      Remarks: remarks
    };
    return this.http.post<any>(endpoint, payload);
  }
  getShippingAddress(payload: { LocationID: number, OutwardNumber: number }): Observable<any> {
    const endpoint = `${this.Baseurl()}StockOutward/GetShippingAddress`;
    return this.http.post<any>(endpoint, payload);
  }
getTransportDetails(payload: { LocationID: number, OutwardNumber: number }): Observable<any> {
    const endpoint = `${this.Baseurl()}StockOutward/GetTransportDetails`;
    return this.http.post<any>(endpoint, payload);
  }
   updateTransportDetails(payload: any): Observable<any> {
    const endpoint = `${this.Baseurl()}StockOutward/UpdateTransportDetails`;
    return this.http.post<any>(endpoint, payload);
  }
  getSubLocationList(locationId: number): Observable<any> {
    const endpoint = `${this.Baseurl()}Masters/GetSubLocationList/${locationId}`;
    return this.http.get<any>(endpoint);
  }
getAddressByPincode(payload: { SearchString: string }): Observable<any> {
  const endpoint = `${this.Baseurl()}Masters/GetAddressByPincode`;
  return this.http.post<any>(endpoint, payload);
}

updateShippingAddress(payload: any): Observable<any> {
  const endpoint = `${this.Baseurl()}StockOutward/UpdateShippingAddress`;
  return this.http.post<any>(endpoint, payload);
}
}
